import React from "react";
import GenericButton from "@ui-components/Button/GenericButton";
import { ReactComponent as IconWarning } from "@assets/Icons/Icon_Warning.svg";

export interface ErrorStateViewProps {
	/** Error message to display */
	message: string;
	/** Optional title override. Default: "Failed to load" */
	title?: string;
	/** If provided, shows a "Try again" button that calls this */
	onRetry?: () => void;
	/** Optional class for the container */
	className?: string;
}

export const ErrorStateView: React.FC<ErrorStateViewProps> = ({
	message,
	title = "Failed to load",
	onRetry,
	className = "",
}) => {
	return (
		<div
			className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}
			role="alert"
		>
			<div className="bg-semantic-bg-danger-primary inline-flex items-center justify-center border border-semantic-border-danger-secondary rounded-md p-3">
				<IconWarning className="h-10 w-10 text-semantic-text-danger" />
			</div>
			<h3 className="text-lg font-bold text-semantic-text-primary mt-4">
				{title}
			</h3>
			<p className="text-sm text-semantic-text-secondary mt-2 max-w-md">
				{message}
			</p>
			{onRetry && (
				<GenericButton
					label="Try again"
					variant="secondary"
					size="sm"
					onClick={onRetry}
					className="mt-4"
				/>
			)}
		</div>
	);
};

export default ErrorStateView;
